/**
 * PLATFORM VALUES
 */

export const PLATFORM_TYPE_SCHEMA = [
  "BATTLESHIP",
  "DESTROYER",
  "FRIGATE",
  "SUBMARINE",
  "AIRCRAFT_CARRIER",
  "MILITARY_HELICOPTER",
  "FIGHTER_JET",
  "BOMBER",
  "DRONE",
  "MOBILE_TRUCK",
  "ARMORED_VEHICLE",
  "TANK",
  "MISSILE_LAUNCHER",
  "STATIC_INSTALLATION",
  "SATELLITE",
  "OTHER",
] as const;

export const PLATFORM_STATUS_SCHEMA = [
  "ACTIVE",
  "STANDBY",
  "MAINTENANCE",
  "DAMAGED",
  "DECOMMISSIONED",
] as const;

export const MOBILITY_TYPE_SCHEMA = [
  "SEA",
  "AIR",
  "LAND",
  "SPACE",
  "FIXED",
] as const;

/**
 * SILOS VALUES
 */

export const SILO_STATUS_VALUES = [
  "ACTIVE",
  "STANDBY",
  "LOADING",
  "RELOADING",
  "MAINTENANCE",
  "DAMAGED",
  "OFFLINE",
] as const;

export const SILO_TYPE_VALUES = [
  "VERTICAL_LAUNCH",
  "HORIZONTAL_LAUNCH",
  "ROTARY",
  "UNDERGROUND",
  "MOBILE_POD",
  "CUSTOM",
] as const;

export const SILO_PLATFORM_LOCATION_VALUES = [
  "BOW",
  "STERN",
  "PORT",
  "STARBOARD",
  "CENTER",
  "TOP",
  "BOTTOM",
  "LEFT_WING",
  "RIGHT_WING",
  "FUSELAGE",
  "ROOF",
  "FRONT",
  "REAR",
  "CUSTOM",
] as const;
